var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"tw-mr-2 tw-w-12 tw-h-12 tw-rounded-full tw-flex tw-items-center tw-justify-center"},[_c('img',{staticClass:"member_circle",attrs:{"src":"img/manu.jpg"}})]),_vm._v(" "),_c('div',[_c('p',{staticClass:"tw-text-sm tw-font-medium member_color"},[_vm._v("Silvio Zschach")])])])
}]

export { render, staticRenderFns }